module.exports = __webpack_public_path__ + "img/home-4-mobileINTpeople.6f758c50.png";